// ── con_daon connector section (mockup) ─────────────────────────────────────
//
// Vendor connector credentials + Daon Process Definitions. PD name / ID are
// free text (they vary per environment and are never interchangeable), version
// is numeric. Local state only — not saved to the workflow JSON.
import { useState } from 'react'
import { Field, TextInput, Toggle } from './fields'
import { ConfigSection } from './ConfigSection'

interface ProcessDef {
  name: string
  id: string
  version: string
}

const emptyPd = (): ProcessDef => ({ name: '', id: '', version: '' })

function PdEditor({ label, pd, onChange }: { label: string; pd: ProcessDef; onChange: (p: ProcessDef) => void }) {
  return (
    <div className="flex flex-col gap-2 border border-[#1e2c44] rounded p-2">
      <p className="text-[10px] uppercase tracking-wide text-[#5b6b85]">{label} process</p>
      <Field label="Process Def Name">
        <TextInput value={pd.name} onChange={(e) => onChange({ ...pd, name: e.target.value })} placeholder="e.g. UATOnboardingDevWorkFlow" />
      </Field>
      <Field label="Process Def ID">
        <TextInput value={pd.id} onChange={(e) => onChange({ ...pd, id: e.target.value })} placeholder="e.g. VAXZEMFI32YJ56BI4PCBVKD2MM" />
      </Field>
      <Field label="Version">
        <TextInput type="number" value={pd.version} onChange={(e) => onChange({ ...pd, version: e.target.value })} placeholder="e.g. 4" />
      </Field>
    </div>
  )
}

export function ConDaonSection() {
  const [apiKey, setApiKey] = useState('')
  const [baseUrl, setBaseUrl] = useState('')
  const [env, setEnv] = useState('uat')
  const [mock, setMock] = useState(false)
  const [idvPd, setIdvPd] = useState(emptyPd())
  const [ocrPd, setOcrPd] = useState(emptyPd())
  const [bioPd, setBioPd] = useState(emptyPd())

  return (
    <ConfigSection title="Daon connector" file="con_daon">
      <Field label="API key (secret path)">
        <TextInput value={apiKey} onChange={(e) => setApiKey(e.target.value)} placeholder="SECRET:sandbox/frankie_kyc_idv/connectors/defaults" />
      </Field>
      <Field label="Base URL">
        <TextInput value={baseUrl} onChange={(e) => setBaseUrl(e.target.value)} placeholder="https://frankieonesandbox.gum.trustx.com" />
      </Field>
      <Field label="Env">
        <TextInput value={env} onChange={(e) => setEnv(e.target.value)} placeholder="uat" />
      </Field>
      <Toggle label="Mock mode" checked={mock} onChange={setMock} />

      <p className="text-[10px] uppercase tracking-wide text-[#5b6b85] mt-1">Process Definitions</p>
      <PdEditor label="IDV" pd={idvPd} onChange={setIdvPd} />
      <PdEditor label="OCR" pd={ocrPd} onChange={setOcrPd} />
      <PdEditor label="Biometrics" pd={bioPd} onChange={setBioPd} />
    </ConfigSection>
  )
}
